export const CONTACT_PHOTO_STATUS_UPLOADED = '1';
export const CONTACT_PHOTO_STATUS_APPROVED = '2';
export const CONTACT_PHOTO_STATUS_REJECTED = '3';
export const CONTACT_PHOTO_STATUS_EXTRACTED = '4';

export type ContactPhotoStatusCode = '1' | '2' | '3' | '4';
